import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a36459ee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36459ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36459ee')) {
      api.createRecord('a36459ee', component.options)
    } else {
      api.reload('a36459ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a36459ee&scoped=true&", function () {
      api.rerender('a36459ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portal/index.vue"
export default component.exports